<template>
  <v-chip v-if="label" class="source-label" :color="color" :text-color="textColor" small>
    {{ label }}
  </v-chip>
</template>

<script>
  import { AB_TEST_VARIANT_LABEL } from "@/constant/abTest";

  export default {
    name: "AbTestVariantSourceLabel",
    props: {
      label: {
        type: String,
        default: null,
      },
    },
    computed: {
      color() {
        return this.label === AB_TEST_VARIANT_LABEL.CALLS_RUNNER ? "success-120" : "info-120";
      },
      textColor() {
        return this.label === AB_TEST_VARIANT_LABEL.CALLS_RUNNER ? "success" : "info";
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";

  .source-label {
    @include text-caption();
    height: 20px !important;
    padding: 0 8px !important;
  }
</style>
